// extracted by mini-css-extract-plugin
export default {"mainContainer":"CPD_mainContainer__iq6hQ","upperWrapper":"CPD_upperWrapper__ZipnQ","bottomWrapper":"CPD_bottomWrapper__7VxU7"};